import React, { useEffect, useState } from 'react'

import { connect, useDispatch, useSelector } from 'react-redux'

import styled from 'styled-components'

import EmptyDetails from '../../EmptyDetails'

import CVDetails from '../../CVDetails'
import DownloadCVModal from '../../print-cv/DownloadCVModal'
import ContextMenu from '../../ContextMenu'

import { downloadModal } from '../../../store/actions/modalActions'
import { SET_DOWNLOAD_MODAL } from '../../../store/actions/types'

import axiosInstance from '../../../services/config/AxiosIntance'

import { addCv } from '../../../store/actions/talentActions'

const TalentDetails = ({ talent, setShowDetails }) => {
  const dispatch = useDispatch()

  const [workExp, setWorkExp] = useState([])
  const [technicalSkills, setTechnicalSkills] = useState([])

  const [loading, setLoading] = useState(false)

  const { uploadedCv } = useSelector((state) => state.talents)

  useEffect(() => {
    talent.meta &&
    JSON.parse(talent.meta).experienceState &&
    JSON.parse(talent.meta).experienceState.length > 0
      ? setWorkExp(JSON.parse(talent.meta).experienceState)
      : setWorkExp([])

    talent.meta &&
    JSON.parse(talent.meta).fullSkills &&
    JSON.parse(talent.meta).fullSkills[0] &&
    JSON.parse(talent.meta).fullSkills[0].length > 0
      ? setTechnicalSkills(JSON.parse(talent.meta).fullSkills[0])
      : setTechnicalSkills([])

    const lists = []

    talent &&
      talent.professional_headline &&
      JSON.parse(talent.professional_headline) &&
      JSON.parse(talent.professional_headline).length > 0 &&
      JSON.parse(talent.professional_headline).forEach(({ item }) => {
        lists.push(item)
      })
  }, [talent])

  useEffect(() => {
    setLoading(true)
    if (talent.cv_public_id) {
      axiosInstance
        .get(`${talent.id}/uploaded-cv`)
        .then((res) => {
          dispatch(addCv(res.data.resp))
          setLoading(false)
        })
        .catch((err) => {
          if (err.response.data.http_code === 404) {
            dispatch(addCv([]))
            setLoading(false)
          }
        })
    } else {
      dispatch(addCv([]))
      setLoading(false)
    }
  }, [talent])

  return (
    <StyledTalentDetails>
      <DownloadCVModal />

      {technicalSkills.length === 0 &&
        workExp.length === 0 &&
        !talent.professional_summary &&
        uploadedCv.length === 0 &&
        !loading && <EmptyDetails />}

      <CVDetails
        isCVLoaded={loading}
        primaryIcon={
          <ContextMenu
            links={[
              {
                name: 'Download CV',
                clickEvent: () => {
                  dispatch({ type: SET_DOWNLOAD_MODAL, payload: true })
                },
              },
            ]}
          />
        }
        closeEvent={() => setShowDetails(false)}
      />

      <hr />
    </StyledTalentDetails>
  )
}

const mapStateToProps = (state) => ({
  talent: state.talents.talent,
  talents: state.talents.talents,
})

export default connect(mapStateToProps, {
  downloadModal,
})(TalentDetails)

const StyledTalentDetails = styled.div`
  position: sticky;
  top: 19vh;
  width: 100%;
  background: #fff;
  height: 100%;
  min-height: 85vh;
  max-height: 85vh;
  margin-left: 1.2rem;
  padding-bottom: 8rem;
`
